import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kWhKmToMiles'
})
export class KWhKmToMilesPipe implements PipeTransform {

  transform(value: number): number {
    if (value === null || value === undefined) {
      return 0;
    }
    // Convert kWh/100 km to miles/kWh.
    const milesPer100Kilometers = 62.137;
    const convertedValue = milesPer100Kilometers / value;

    return parseFloat(convertedValue.toFixed(2));
  }
}
